(function(config) {
    'use strict';

    angular.module('order.services', [
            'ngResource'
        ])
        .factory('orderDeliveriesDataSrvc', orderDeliveriesDataSrvc)
        .factory('orderDataSrvc', orderDataSrvc)
        .factory('orderSrvc', orderSrvc)
        .factory('orderLogDataSrvc', orderLogDataSrvc)
        .factory('invoiceDataSrvc', invoiceDataSrvc)
        .factory('invoiceLegacyDataSrvc', invoiceLegacyDataSrvc)
        .factory('orderDeliveryPackageDataSrvc', orderDeliveryPackageDataSrvc)
        .factory('orderProductDataSrvc', orderProductDataSrvc)
        .factory('orderProductByDeliveryDataSrvc', orderProductByDeliveryDataSrvc)
        .factory('orderProductFilesPagesDataSrvc', orderProductFilesPagesDataSrvc)
        .factory('previewModalSrvc', previewModalSrvc)
        .factory('previewSrvc', previewSrvc)
        .factory('orderProductFileDataSrvc', orderProductFileDataSrvc)
        .factory('qHttp', qHttp)
        .factory('operationDataSrvc', operationDataSrvc)
        .factory('couriersDataSrvc', couriersDataSrvc)
        .factory('sourceFileDataSrvc', sourceFileDataSrvc)
        .factory('sourceFileModalSrvc', sourceFileModalSrvc)
        .factory('orderShelfDataSrvc', orderShelfDataSrvc)
        .factory('orderShelfModalSrvc', orderShelfModalSrvc)
        .factory('orderShelfNotificationDataSrvc', orderShelfNotificationDataSrvc)
        .factory('orderProductEditModalSrvc', orderProductEditModalSrvc)

    orderDeliveryPackageDataSrvc.$inject = ['$resource'];

    function orderDeliveryPackageDataSrvc($resource) {
        return $resource(config.api + '/api/v1/order-delivery-packages/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET'
            },
            update: {
                method: 'PATCH'
            },
            statusUpdate: {
                method: 'PATCH',
                url: config.api + '/api/v1/order-delivery-packages/:pk/status-update/',
                params: {
                    pk: '@pk'
                }
            },
        });
    }

    orderDeliveriesDataSrvc.$inject = ['$resource'];

    function orderDeliveriesDataSrvc($resource) {
        return $resource(config.api + '/api/v1/order-deliveries/:pk/', { pk: '@pk' }, {
            update: {
                method: 'PATCH'
            },
            generateLabel: {
                method: 'PATCH',
                url: config.api + '/api/v1/order-deliveries/:pk/admin_generate_label/',
                params: {
                    pk: '@pk'
                },
                unique: true
            }
        });
    }

    orderLogDataSrvc.$inject = ['$resource'];

    function orderLogDataSrvc($resource) {
        return $resource(config.api + '/api/v1/order-logs/:pk/', { pk: '@pk' }, {
            list: {
                method: 'GET',
                url: config.api + '/api/v1/order-logs/',
                params: {
                    page: '@page'
                }
            }
        });
    }

    invoiceDataSrvc.$inject = ['$resource', 'transformResponseSrvc'];

    function invoiceDataSrvc($resource, transformResponseSrvc) {
        return $resource(config.api + '/api/v1/invoices/:pk/', { pk: '@pk' }, {
            list: {
                method: 'GET',
                url: config.api + '/api/v1/invoices/',
                params: {
                    page: '@page'
                }
            },
            exportCsv: {
                method: 'GET',
                url: config.api + '/api/v1/invoices/admin_export_csv/',
                responseType: 'arraybuffer',
                transformResponse: transformResponseSrvc.csvArrayBufferTransform
            },
            exportJpkFa: {
                method: 'GET',
                url: config.api + '/api/v1/invoices/admin_export_jpkfa/',
                responseType: 'arraybuffer',
                transformResponse: transformResponseSrvc.xmlArrayBufferTransform
            }
        });
    }

    invoiceLegacyDataSrvc.$inject = ['$resource'];

    function invoiceLegacyDataSrvc($resource) {
        return $resource(config.api + '/api/v1/legacy-invoices/:pk/', { pk: '@pk' }, {
            list: {
                method: 'GET',
                url: config.api + '/api/v1/legacy-invoices/',
                params: {
                    page: '@page'
                }
            }
        });
    }

    orderDataSrvc.$inject = ['$resource', 'transformResponseSrvc', 'transformRequestSrvc'];

    function orderDataSrvc($resource, transformResponseSrvc, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/orders/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                url: config.api + '/api/v1/orders/',
                params: {
                    page: '@page'
                },
            },
            duplicateOrder: {
                method: 'POST',
                url: config.api + '/api/v1/orders/:pk/admin_duplicate/',
                params: {
                    pk: '@pk'
                }
            },
            payAnOrder: {
                method: 'POST',
                url: config.api + '/api/v1/orders/:pk/admin_pay_an_order/',
                params: {
                    pk: '@pk'
                }
            },
            completeAnOrder: {
                method: 'POST',
                url: config.api + '/api/v1/orders/:pk/admin_complete_an_order/',
                params: {
                    pk: '@pk'
                }
            },
            cancelAnOrder: {
                method: 'POST',
                url: config.api + '/api/v1/orders/:pk/admin_cancel_an_order/',
                params: {
                    pk: '@pk'
                }
            },
            issueVatInvoice: {
                method: 'POST',
                url: config.api + '/api/v1/orders/:pk/admin_issue_vat_invoice/',
                params: {
                    pk: '@pk'
                }
            },
            stopDelivery: {
                method: 'POST',
                url: config.api + '/api/v1/orders/:pk/admin_stop_delivery/',
                params: {
                    pk: '@pk'
                }
            },
            unstopDelivery: {
                method: 'POST',
                url: config.api + '/api/v1/orders/:pk/admin_unstop_delivery/',
                params: {
                    pk: '@pk'
                }
            },
            sendCheck: {
                method: 'GET',
                url: config.api + '/api/v1/orders/:pk/admin_send_check/',
                params: {
                    pk: '@pk'
                }
            },
            sendUpsGet: {
                method: 'GET',
                url: config.api + '/api/v1/orders/:pk/admin_send_ups_retrieve/',
                params: {
                    pk: '@pk'
                }
            },
            card: {
                method: 'GET',
                url: config.api + '/api/v1/orders/:pk/admin_card/',
                params: {
                    pk: '@pk'
                },
                responseType: 'arraybuffer',
                transformResponse: transformResponseSrvc.pdfArrayBufferTransform
            },
            proformaInvoice: {
                method: 'GET',
                url: config.api + '/api/v1/orders/:pk/proforma_invoice/',
                params: {
                    pk: '@pk'
                },
                responseType: 'arraybuffer',
                transformResponse: transformResponseSrvc.pdfArrayBufferTransform
            },
            advanceInvoice: {
                method: 'GET',
                url: config.api + '/api/v1/orders/:pk/advance_invoice/',
                params: {
                    pk: '@pk'
                },
                responseType: 'arraybuffer',
                transformResponse: transformResponseSrvc.pdfArrayBufferTransform
            },
            finalInvoice: {
                method: 'GET',
                url: config.api + '/api/v1/orders/:pk/final_invoice/',
                params: {
                    pk: '@pk'
                },
                responseType: 'arraybuffer',
                transformResponse: transformResponseSrvc.pdfArrayBufferTransform
            },
            vatInvoice: {
                method: 'GET',
                url: config.api + '/api/v1/orders/:pk/vat_invoice/',
                params: {
                    pk: '@pk'
                },
                responseType: 'arraybuffer',
                transformResponse: transformResponseSrvc.pdfArrayBufferTransform
            },
            clientContact: {
                method: 'GET',
                isArray: true,
                url: config.api + '/api/v1/orders/client_contact_list/',
                params: {
                    client_pk: '@client_pk'
                }
            },
            paymentsImport: {
                method: 'POST',
                url: config.api + '/api/v1/orders/admin_payments_import/',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            create: {
                method: 'POST',
                url: config.api + '/api/v1/orders/admin_create/',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.nestedFormDataTransform
            },
            paymentMethods: {
                method: 'GET',
                url: config.api + '/api/v1/admin-payment-methods/',
                isArray: false
            },
            deliveryOptions: {
                method: 'GET',
                url: config.api + '/api/v1/orders/:pk/admin_get_order_delivery_options/',
                params: {
                    pk: '@pk'
                },
                isArray: false
            },
            updateExternal: {
                method: 'PATCH',
                url: config.api + '/api/v1/orders/:pk/admin_update_external/',
                params: {
                    pk: '@pk'
                }
            },
            externalOrderConfirm: {
                method: 'PATCH',
                url: config.api + '/api/v1/orders/:pk/admin_external_order_confirm/',
                params: {
                    pk: '@pk'
                }
            },
            negotiate: {
                method: 'PATCH',
                url: config.api + '/api/v1/orders/:pk/admin_negotiate_price/',
                params: {
                    pk: '@pk'
                }
            },
            senderAddressUpdate: {
                method: 'POST',
                url: config.api + '/api/v1/orders/:pk/admin_update_sender_address/',
                params: {
                    pk: '@pk'
                }
            }
        });
    }

    orderSrvc.$inject = ['$uibModal', 'modalSrvc', 'notificationSrvc', 'downloadLinkSrvc', 'orderDataSrvc', 'orderPaymentConst', 'orderStatusConst', 'orderUpdateMessagesConst', 'orderPaymentMethodConst', 'invoiceTypeConst', 'orderDeliveryStatusConst'];

    function orderSrvc($uibModal, modalSrvc, notificationSrvc, downloadLinkSrvc, orderDataSrvc, orderPaymentConst, orderStatusConst, orderUpdateMessagesConst, orderPaymentMethodConst, invoiceTypeConst, orderDeliveryStatusConst) {

        function isDisablePaid(order) {
            if (order.payment_method === orderPaymentMethodConst.deadline.value) {
                return order.payment_status === orderPaymentConst.paid.value;
            }

            if (order.payment_method === orderPaymentMethodConst.after_receiving.value &&
                order.client.limit_data.is_payment_deadline_limit_active) {
                return order.payment_status === orderPaymentConst.paid.value;
            }

            if (order.is_external) {
                return (order.status !== orderStatusConst.waiting_for_payment.value &&
                    order.status !== orderStatusConst.in_realization.value &&
                    order.status !== orderStatusConst.in_production.value) ||
                    order.payment_method === orderPaymentMethodConst.after_receiving.value ||
                    order.payment_status === orderPaymentConst.paid.value

            } else {
                return order.status !== orderStatusConst.waiting_for_payment.value ||
                    order.payment_method === orderPaymentMethodConst.after_receiving.value;
            }
        }

        function isDisableCompleted(order) {
            return order.status !== orderStatusConst.in_realization.value &&
                order.status !== orderStatusConst.in_production.value;
        }

        function isDisableCanceled(order) {
            return order.status === orderStatusConst.canceled.value ||
                order.status === orderStatusConst.in_production.value ||
                order.status === orderStatusConst.done.value ||
                order.status === orderStatusConst.deleted.value;
        }

        function isDisableStopDelivery(order) {
            return order.delivery_status !== orderDeliveryStatusConst.not_send.value;
        }

        function isDisableUnstopDelivery(order) {
            return order.delivery_status !== orderDeliveryStatusConst.stopped.value;
        }

        function isDisableExternalOrderConfirm(order) {
            return !!order.proforma_invoice;
        }

        function isVisibleIssueVatInvoice(order) {
            return !order.vat_invoice &&
                order.payment_method === orderPaymentMethodConst.after_receiving.value &&
                order.status === orderStatusConst.done.value;
        }

        function payAnOrder(order, successCallback) {
            $uibModal.open({
                templateUrl: 'app/order/views/order-pay-modal/order-pay-modal.html',
                controller: 'OrderPayModalController',
                controllerAs: 'ctrl',
                resolve: {
                    is_external: function() {
                        return order.is_external;
                    },
                    gross_value: function() {
                        return order.info.final_gross_price;
                    }
                }
            }).result.then(
                function(partial_amount) {
                    var data = {
                        pk: order.pk
                    };

                    if (order.is_external && partial_amount) {
                        data.partial_amount = partial_amount;
                    }

                    orderDataSrvc.payAnOrder(data).$promise.then(
                        function(response) {
                            order.status = response.status;
                            order.status_display = orderStatusConst[response.status].title;
                            order.payment_status = response.payment_status;
                            order.payment_status_display = orderPaymentConst[response.payment_status].title;
                            notificationSrvc.notification("success", orderUpdateMessagesConst.paid);

                            if (successCallback) {
                                successCallback(response);
                            }

                            return response;
                        },
                        function(response) {
                            notificationSrvc.notification("error", response.data.nonFieldErrors.join('; '));
                        }
                    );
                },
                angular.noop
            );
        }

        function duplicateOrder(order, onConfirm, okCallback, cancelCallback) {
            $uibModal.open({
                templateUrl: 'app/order/views/order-duplicate-modal/order-duplicate-modal.html',
                controller: 'OrderDuplicateModalController',
                controllerAs: 'ctrl',
                resolve: {
                    order: function() {
                        return order;
                    }
                }
            }).result.then(
                function() {
                    if (onConfirm) onConfirm();

                    orderDataSrvc.duplicateOrder({pk: order.pk}).$promise.then(
                        function(response) {
                            notificationSrvc.notification("success", orderUpdateMessagesConst.duplicated);
                            if (okCallback) okCallback(response);
                            return response;
                        },
                        function(response) {
                            notificationSrvc.notification("error", response.data.non_field_errors.join('; '));
                            if (cancelCallback) cancelCallback();
                            return response;
                        }
                    );
                },
                function() {
                    if (cancelCallback) cancelCallback();
                }
            );
        }

        function completeAnOrder(order, successCallback) {
            return modalSrvc.confirmAction(
                orderUpdateMessagesConst.confirmCompletedTitle,
                function() {
                    orderDataSrvc.completeAnOrder({
                        pk: order.pk
                    }).$promise.then(
                        function(response) {
                            order.status = orderStatusConst.done.value;
                            order.status_display = orderStatusConst.done.title;
                            notificationSrvc.notification("success", orderUpdateMessagesConst.completed);

                            if (successCallback) {
                                successCallback(response);
                            }

                            return response;
                        },
                        function(response) {
                            notificationSrvc.notification("error", response.data.nonFieldErrors.join('; '));
                        }
                    );
                }
            );
        }

        function cancelAnOrder(order, successCallback) {
            return modalSrvc.confirmAction(
                orderUpdateMessagesConst.confirmCanceledTitle,
                function() {
                    orderDataSrvc.cancelAnOrder({
                        pk: order.pk
                    }).$promise.then(
                        function(response) {
                            order.status = orderStatusConst.canceled.value;
                            order.status_display = orderStatusConst.canceled.title;
                            notificationSrvc.notification("success", orderUpdateMessagesConst.canceled);

                            if (successCallback) {
                                successCallback(response);
                            }

                            return response;
                        },
                        function(response) {
                            notificationSrvc.notification("error", response.data.nonFieldErrors.join('; '));
                        }
                    );
                }
            );
        }

        function stopDelivery(order, successCallback) {
            return $uibModal.open({
                templateUrl: 'app/order/views/order-stop-delivery/order-stop-delivery.html',
                controller: 'OrderStopDeliveryController',
                controllerAs: 'ctrl',
                resolve: {
                    order: function() {
                        return order;
                    }
                }
            }).result.then(
                function(result) {
                    if (successCallback) {
                        successCallback(result);
                    }
                }
            );
        }

        function unstopDelivery(order, successCallback) {
            return modalSrvc.confirmAction(
                orderUpdateMessagesConst.confirmUnstopDeliveryTitle,
                function() {
                    orderDataSrvc.unstopDelivery({
                        pk: order.pk
                    }).$promise.then(
                        function(response) {
                            order.delivery_status = orderDeliveryStatusConst.not_send.value;
                            order.delivery_status_display = orderDeliveryStatusConst.not_send.title;
                            order.delivery_lock_reason = null;
                            notificationSrvc.notification("success", orderUpdateMessagesConst.unstopped);

                            if (successCallback) {
                                successCallback(response);
                            }

                            return response;
                        },
                        function(response) {
                            notificationSrvc.notification("error", response.data.nonFieldErrors.join('; '));
                        }
                    );
                }
            );
        }

        function getOrderCard(order) {
            return orderDataSrvc.card({
                pk: order.pk
            }).$promise.then(
                function(response) {
                    downloadLinkSrvc.saveFile(response);
                    return response;
                }
            );
        }

        function getInvoice(order_pk, type) {
            if (type === invoiceTypeConst.proforma) {
                return getProformaInvoicePdf(order_pk);
            } else if (type === invoiceTypeConst.advance) {
                return getAdvanceInvoicePdf(order_pk);
            } else if (type === invoiceTypeConst.final) {
                return getFinalInvoicePdf(order_pk);
            } else if (type === invoiceTypeConst.vat) {
                return getVATInvoicePdf(order_pk);
            }
        }

        function getProformaInvoicePdf(order_pk) {
            return orderDataSrvc.proformaInvoice({
                pk: order_pk
            }).$promise.then(
                function(response) {
                    downloadLinkSrvc.saveFile(response);
                    return response;
                }
            );
        }

        function getAdvanceInvoicePdf(order_pk) {
            return orderDataSrvc.advanceInvoice({
                pk: order_pk
            }).$promise.then(
                function(response) {
                    downloadLinkSrvc.saveFile(response);
                    return response;
                }
            );
        }

        function getFinalInvoicePdf(order_pk) {
            return orderDataSrvc.finalInvoice({
                pk: order_pk
            }).$promise.then(
                function(response) {
                    downloadLinkSrvc.saveFile(response);
                    return response;
                }
            );
        }

        function getVATInvoicePdf(order_pk) {
            return orderDataSrvc.vatInvoice({
                pk: order_pk
            }).$promise.then(
                function(response) {
                    downloadLinkSrvc.saveFile(response);
                    return response;
                }
            );
        }

        return {
            isDisablePaid: isDisablePaid,
            isDisableCompleted: isDisableCompleted,
            isDisableCanceled: isDisableCanceled,
            isDisableStopDelivery: isDisableStopDelivery,
            isDisableUnstopDelivery: isDisableUnstopDelivery,
            isDisableExternalOrderConfirm: isDisableExternalOrderConfirm,
            isVisibleIssueVatInvoice: isVisibleIssueVatInvoice,
            duplicateOrder: duplicateOrder,
            payAnOrder: payAnOrder,
            completeAnOrder: completeAnOrder,
            cancelAnOrder: cancelAnOrder,
            stopDelivery: stopDelivery,
            unstopDelivery: unstopDelivery,

            getOrderCard: getOrderCard,

            getInvoice: getInvoice,
            getProformaInvoicePdf: getProformaInvoicePdf,
            getAdvanceInvoicePdf: getAdvanceInvoicePdf,
            getFinalInvoicePdf: getFinalInvoicePdf,
            getVATInvoicePdf: getVATInvoicePdf,
        };
    }

    orderProductDataSrvc.$inject = ['$resource'];

    function orderProductDataSrvc($resource) {
        return $resource('', {}, {
            sendUpsUpdateRealWeight: {
                method: 'PATCH',
                url: config.api + '/api/v1/order-products/:pk/admin_send_ups_update_real_weight/',
                params: {
                    pk: '@pk'
                }
            },
            getFileData: {
                method: 'GET',
                url: config.api + '/api/v1/order-products/:pk/admin_get_file_data/',
                params: {
                    pk: '@pk'
                }
            },
            getChosenOptions: {
                method: 'GET',
                url: config.api + '/api/v1/order-products/:pk/admin_get_chosen_options/',
                params: {
                    pk: '@pk'
                }
            },
            adminUpdate: {
                method: 'PATCH',
                url: config.api + '/api/v1/order-products/:pk/admin_update/',
                params: {
                    pk: '@pk'
                }
            }
        });
    }

    orderProductByDeliveryDataSrvc.$inject = ['$resource'];

    function orderProductByDeliveryDataSrvc($resource) {
        return $resource('', {}, {
            sendUpsUpdateRealWeight: {
                method: 'PATCH',
                url: config.api + '/api/v1/order-products-by-deliveries/:pk/admin_send_ups_update_real_weight/',
                params: {
                    pk: '@pk'
                }
            }
        });
    }

    orderProductFilesPagesDataSrvc.$inject = ['$resource'];

    function orderProductFilesPagesDataSrvc($resource) {
        return $resource(config.api + '/api/v1/order-product-files-pages/:pk/', { pk: '@pk' }, {
            getPagePreview: {
                method: 'GET',
                url: config.api + '/api/v1/order-product-files-pages/:pk/get_page_preview/',
                responseType: 'blob',
                transformResponse: function(data, headersGetter) {
                    return { data : data };
                }
            },
            update: {
                method: 'PATCH',
                isArray: true
            },
            acceptAll: {
                method: 'POST',
                url: config.api + '/api/v1/order-product-files-pages/accept_all/',
                isArray: true
            },
        });
    }

    previewModalSrvc.$inject = ['$uibModal'];

    function previewModalSrvc($uibModal) {
        return {
            previewModal: previewModal,
            altPreviewModal: altPreviewModal,
            fileImagePreviewModal: fileImagePreviewModal,
            openFileModal: openFileModal
        };

        function previewModal(orderProduct, okCallback, cancelCallback) {
            $uibModal.open({
                templateUrl: 'app/order/views/preview-modal/preview-modal.html',
                controller: 'PreviewModalController',
                controllerAs: 'ctrl',
                size: 'xl',
                windowClass: 'admin-preview-modal',
                resolve: {
                    orderProduct: function () {
                        return orderProduct;
                    }
                }
            }).result.then(okCallback, cancelCallback);
        }

        function altPreviewModal(orderProduct, okCallback, cancelCallback) {
            $uibModal.open({
                templateUrl: 'app/order/views/alt-preview-modal/alt-preview-modal.html',
                controller: 'AltPreviewModalController',
                controllerAs: 'ctrl',
                size: 'xl',
                windowClass: 'admin-preview-modal',
                resolve: {
                    orderProduct: function () {
                        return orderProduct;
                    }
                }
            }).result.then(okCallback, cancelCallback);
        }

        function fileImagePreviewModal(fileImage, okCallback, cancelCallback) {
            $uibModal.open({
                templateUrl: 'app/order/views/file-image-preview-modal/file-image-preview-modal.html',
                controller: 'FileImagePreviewController',
                controllerAs: 'ctrl',
                size: 'xl',
                windowClass: 'admin-preview-modal file-image-modal',
                resolve: {
                    fileImage: function () {
                        return fileImage;
                    }
                }
            }).result.then(okCallback, cancelCallback);
        }

        function openFileModal(orderProduct, okCallback, cancelCallback) {
            return $uibModal.open({
                templateUrl: 'app/order/views/order-product-file-modal/order-product-file-modal.html',
                controller: 'OrderProductFileModalController',
                controllerAs: 'ctrl',
                size: 'lg',
                resolve: {
                    orderProduct: function() {
                        return orderProduct;
                    }
                }
            }).result.then(okCallback, cancelCallback);
        }
    }

    previewSrvc.$inject = ['previewModalSrvc', 'saveFileSrvc', 'webglSrvc'];

    function previewSrvc(previewModalSrvc, saveFileSrvc, webglSrvc) {
        return {
            previewOrderFile: previewOrderFile,
            getClientFile: getClientFile,
            isClientFileNotAvailable: isClientFileNotAvailable,
            getClientCoverFile: getClientCoverFile,
            isClientCoverFileNotAvailable: isClientCoverFileNotAvailable,
            getResultFile: getResultFile,
            isResultFileNotAvailable: isResultFileNotAvailable,
            getCoverResultFile: getCoverResultFile,
            isCoverResultFileNotAvailable: isCoverResultFileNotAvailable,
            isAdminCanNotUploadFile: isAdminCanNotUploadFile
        };

        function previewOrderFile(orderProduct, okCallback, cancelCallback) {
            if (typeof okCallback !== 'function') {
                okCallback = angular.noop;
            }

            if (typeof cancelCallback !== 'function') {
                cancelCallback = angular.noop;
            }

            if (orderProduct.product_file) {
                if (webglSrvc.check()) {
                    previewModalSrvc.previewModal(orderProduct, okCallback, cancelCallback)
                } else {
                    previewModalSrvc.altPreviewModal(orderProduct, okCallback, cancelCallback)
                }
            }
        }

        function getClientFile(orderProduct) {
            if (orderProduct.product_file) {
                return saveFileSrvc.saveFile(
                    orderProduct.product_file.client_file_url,
                    orderProduct.product_file.client_file_name
                );
            }
        }

        function isClientFileNotAvailable(orderProduct) {
            return !(!!orderProduct.product_file && !!orderProduct.product_file.client_file_url);
        }

        function getResultFile(orderProduct) {
            if (orderProduct.product_file) {
                return saveFileSrvc.saveFile(
                    orderProduct.product_file.preflight_result,
                    orderProduct.product_file.preflight_result_name
                );
            }
        }

        function isResultFileNotAvailable(orderProduct) {
            return !(!!orderProduct.product_file && !!orderProduct.product_file.preflight_result);
        }

        function getClientCoverFile(orderProduct) {
            if (orderProduct.product_file) {
                return saveFileSrvc.saveFile(
                    orderProduct.product_file.client_cover_file_url,
                    orderProduct.product_file.client_cover_file_name
                );
            }
        }

        function isClientCoverFileNotAvailable(orderProduct) {
            return !(!!orderProduct.product_file && !!orderProduct.product_file.client_cover_file_url);
        }

        function getCoverResultFile(orderProduct) {
            if (orderProduct.product_file) {
                return saveFileSrvc.saveFile(
                    orderProduct.product_file.cover_preflight_result,
                    orderProduct.product_file.cover_preflight_result_name
                );
            }
        }

        function isCoverResultFileNotAvailable(orderProduct) {
            return !(!!orderProduct.product_file && !!orderProduct.product_file.cover_preflight_result);
        }

        function isAdminCanNotUploadFile(orderProduct) {
            return !orderProduct.is_allegro_source;
        }
    }

    orderProductFileDataSrvc.$inject = ['$resource', 'transformRequestSrvc', 'transformResponseSrvc'];
    function orderProductFileDataSrvc($resource, transformRequestSrvc, transformResponseSrvc) {
        return $resource(config.api + '/api/v1/order-product-files/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET'
            },
            create: {
                method: 'POST',
                url: config.api + '/api/v1/order-product-files/',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            update: {
                method: 'PATCH',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            delete: {
                method: 'DELETE'
            },
        });
    }

    sourceFileDataSrvc.$inject = ['$resource', 'transformRequestSrvc', 'transformResponseSrvc'];
    function sourceFileDataSrvc($resource, transformRequestSrvc, transformResponseSrvc) {
        return $resource(config.api + '/api/v1/order-source-files/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET'
            },
            create: {
                method: 'POST',
                url: config.api + '/api/v1/order-source-files/',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            update: {
                method: 'PATCH',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
        });
    }

    sourceFileModalSrvc.$inject = ['$uibModal'];
    function sourceFileModalSrvc($uibModal) {
        return {
            openSourceFileModal: openSourceFileModal
        };

        function openSourceFileModal(orderProduct, okCallback, cancelCallback) {
            return $uibModal.open({
                templateUrl: 'app/order/views/order-product-source-file-modal/order-product-source-file-modal.html',
                controller: 'OrderProductSourceFileModalController',
                controllerAs: 'ctrl',
                size: 'lg',
                resolve: {
                    orderProduct: function() {
                        return orderProduct;
                    }
                }
            }).result.then(okCallback, cancelCallback);
        }
    }

    orderProductEditModalSrvc.$inject = ['$uibModal'];

    function orderProductEditModalSrvc($uibModal) {
        return {
            editOrderProduct: editOrderProduct
        };

        function editOrderProduct(orderProduct, okCallback, cancelCallback) {
            return $uibModal.open({
                templateUrl: 'app/order/views/order-product-edit-modal/order-product-edit-modal.html',
                controller: 'OrderProductEditModalController',
                controllerAs: 'ctrl',
                size: 'lg',
                resolve: {
                    orderProduct: function() {
                        return orderProduct;
                    }
                }
            }).result.then(okCallback, cancelCallback);
        }
    }

    qHttp.$inject = ['$q'];

    function qHttp($q) {

        var queue = [];

        var execNext = function (fn) {
            var task = queue[0],
                result = fn(task.c),
                promise = result.hasOwnProperty('$promise') ? result.$promise : result;


            promise.then(
                function (data) {
                    queue.shift();
                    task.d.resolve(data);

                    if (queue.length > 0) execNext(fn);
                }, function (err) {
                    queue.shift();
                    task.d.reject(err);

                    if (queue.length > 0) execNext(fn);
                }
            );
        };

        return function (fn, config) {
            var d = $q.defer();

            queue.push({
                c: config,
                d: d
            });

            if (queue.length === 1) execNext(fn);

            return d.promise;
        };
    }

    operationDataSrvc.$inject = ['$resource', 'transformResponseSrvc', 'transformRequestSrvc'];

    function operationDataSrvc($resource, transformResponseSrvc, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/optima/', {}, {
            dotpay: {
                method: 'GET',
                url: config.api + '/api/v1/optima/dotpay_operations/',
                responseType: 'arraybuffer',
                transformResponse: transformResponseSrvc.txtArrayBufferTransform
            },
            pko: {
                method: 'POST',
                url: config.api + '/api/v1/optima/pko_operations/',
                responseType: 'arraybuffer',
                transformResponse: transformResponseSrvc.txtArrayBufferTransform,
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            }
        });
    }

    couriersDataSrvc.$inject = ['$resource'];

    function couriersDataSrvc($resource) {
        return $resource(config.api + '/api/v1/couriers/', {}, {
            getCollectionPoints: {
                method: 'GET',
                url: config.api + '/api/v1/couriers/collection_points/',
                isArray: true
            }
        });
    }

    orderShelfDataSrvc.$inject = ['$resource'];
    function orderShelfDataSrvc($resource) {
        return $resource(config.api + '/api/v1/order-shelfs/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST',
                url: config.api + '/api/v1/order-shelfs/',
            },
            update: {
                method: 'PATCH'
            }
        });
    }

    orderShelfModalSrvc.$inject = ['$uibModal'];
    function orderShelfModalSrvc($uibModal) {
        return {
            modal: modal
        };

        function modal(dataObj, okCallback, cancelCallback) {
            $uibModal.open({
                templateUrl: 'app/order/views/order-shelf-modal/order-shelf-modal.html',
                controller: 'OrderShelfModalController',
                controllerAs: 'ctrl',
                size: 'md',
                windowClass: 'order-shelf-modal',
                resolve: {
                    dataObj: function () {
                        return dataObj;
                    }
                }
            }).result.then(okCallback, cancelCallback);
        }
    }

    orderShelfNotificationDataSrvc.$inject = ['$resource'];
    function orderShelfNotificationDataSrvc($resource) {
        return $resource(config.api + '/api/v1/order-shelf-notifications/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST',
                url: config.api + '/api/v1/order-shelf-notifications/',
            }
        });
    }

})(window.config);
